module.exports = __webpack_public_path__ + "img/law-serve-nav-icon02.267c6c1d.png";